import { EmployeeLiteModel } from 'api-hooks/employee';
import { Expose, Type } from 'class-transformer';
import { TransactionalStatusEnum } from 'common/constants/enum';
import {
  CommonModel,
  CommonParamInput,
} from 'common/repositories/common.model';

// Enum

export enum AccountTypeEnum {
  bank = 'bank',
  cash = 'cash',
}

export class AccountableLiteModel extends CommonModel {
  balance: string;
  code: string;
  description: string;
  name: string;

  @Expose({ name: 'account_number' })
  accountNumber: string;
}

export class TransferModel {
  id: string;
  description: string;
  number: string;
  status: TransactionalStatusEnum;

  @Expose({ name: 'ref_id' })
  refId: string;

  @Expose({ name: 'transaction_at' })
  @Type(() => Date)
  transactionAt: Date;

  @Type(() => Number)
  amount: number;

  @Expose({ name: 'from_account_type' })
  fromAccountType: string;

  @Expose({ name: 'to_account_type' })
  toAccountType: string;

  @Expose({ name: 'to_accountable' })
  @Type(() => AccountableLiteModel)
  toAccountable: AccountableLiteModel;

  @Expose({ name: 'from_accountable' })
  @Type(() => AccountableLiteModel)
  fromAccountable: AccountableLiteModel;

  @Expose({ name: 'is_resolved' })
  isResolved: boolean;
}

export class TransferLiteModel extends CommonModel {
  amount: number;
  description: string;
  number: string;
  status: TransactionalStatusEnum;

  @Expose({ name: 'transaction_at' })
  @Type(() => Date)
  transactionAt: Date;

  @Expose({ name: 'from_account_type' })
  fromAccountType: string;

  @Expose({ name: 'to_account_type' })
  toAccountType: string;

  @Expose({ name: 'to_accountable' })
  @Type(() => AccountableLiteModel)
  toAccountable: AccountableLiteModel;

  @Expose({ name: 'from_accountable' })
  @Type(() => AccountableLiteModel)
  fromAccountable: AccountableLiteModel;

  @Expose({ name: 'created_by' })
  @Type(() => EmployeeLiteModel)
  createdBy: EmployeeLiteModel;
}

export class getTransfersInput {
  params: CommonParamInput;
}

export class getTransferInput {
  id: string;
}

export class TransferMutationInput {
  transactionAt: Date;
  needApproval: boolean;
  amount: number;
  description: string;
  fromAccountType: string;
  fromAccountable: string;
  toAccountType: string;
  toAccountable: string;
}

export class TransferUpdateInput {
  transferId: string;
  body: TransferMutationInput;
}

export class TransferDeleteInput {
  transferId: string;
}
